

export const getNotificationsFieldsToEdit = ({
  webhooks,
}) => [
  {
    fieldName: 'crmApiIntegration',
    label: 'CRM API Integration',
    subTitle:
      'Connect Zorba deals directly to your CRM with webhooks and get notified when a seller lowers their asking price.',
    value: webhooks,
  },
];